import React, { FC, useEffect, useState } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { Order } from 'models/order';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

type OrderVersionSelectProps = {
    order: Order;
    selectedVersion: number;
    onVersionSelect: (version: number) => void;
};
const OrderVersionSelect: FC<OrderVersionSelectProps> = ({
    order,
    onVersionSelect,
    selectedVersion,
}: OrderVersionSelectProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [version, setVersion] = useState(1);

    const onVersionChange = (event: SelectChangeEvent<number>) => {
        const version = parseInt(event.target.value.toString());
        setVersion(version);
        onVersionSelect(version);
    };

    useEffect(() => {
        setVersion(selectedVersion > 0 ? selectedVersion : order.version);
    }, [order, selectedVersion]);

    return (
        <Select fullWidth value={version} onChange={onVersionChange} data-test="order-version-select">
            {order.availableVersions.map((availableVersion) => {
                return (
                    <MenuItem key={availableVersion.version} value={availableVersion.version}>
                        {translate('orders:VERSION')} {availableVersion.version} -{' '}
                        {formatDate(new Date(availableVersion.createdAt), 'datetime')}
                    </MenuItem>
                );
            })}
        </Select>
    );
};

export default OrderVersionSelect;
